// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7e797716","284":"38908ed0","395":"f2f1e0f6","667":"715afad8","675":"6e101ab9","787":"e6667cdd","853":"a8a3554a","856":"05c04fd7","923":"4b8ace25","951":"012a40f1"}[chunkId] + ".chunk.js";
};